import {
	ADMINADDORUPDATELOYALTYPOINT_SUCCESS,
	ADMINADDORUPDATELOYALTYPOINT_FAILED,
	RESET_ADMINADDORUPDATELOYALTYPOINT,
	LOADING_ADMINADDORUPDATELOYALTYPOINT,
	NETWORK_ERROR_ADMINADDORUPDATELOYALTYPOINT
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINADDORUPDATELOYALTYPOINT:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {}
			};
		case ADMINADDORUPDATELOYALTYPOINT_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload
			};
		case ADMINADDORUPDATELOYALTYPOINT_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload
			};
		case NETWORK_ERROR_ADMINADDORUPDATELOYALTYPOINT:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {}
			};
		case RESET_ADMINADDORUPDATELOYALTYPOINT:
			return (state = initialState);
		default:
			return state;
	}
};
